module.exports = __webpack_public_path__ + "static/media/avi.389fb4f0.svg";